module.exports = __webpack_public_path__ + "static/img/tjyy.b601e785.png";